// extracted by mini-css-extract-plugin
export default {"fieldSet":"event-details_fieldSet__13q1H","dropdowns":"event-details_dropdowns__W4v2U"};